export const KEY_COMPETITORS_ICON_OVERLAP_PX = 12;

export const KEY_COMPETITORS_CHIP_LABEL_KEY = "compare.shared.key_competitors_suggestion.label";

export const KEY_COMPETITORS_CHIP_AUTOMATION = "website-query-bar-key-competitors";
